import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders ,} from '@angular/common/http';
import { Globals } from 'src/app/globals';
import { Approved } from '../modal/approved';


@Injectable({
    providedIn: 'root'
})

export class StaredService {
    constructor(private httpclient: HttpClient, private global: Globals) { }

    // headers: any = ({
    //     'Authorization': "Bearer " + this.global.loggedUser.token
    // })

    // headers:HttpHeaders=new HttpHeaders;
    GetStaredList() {
        let headers:HttpHeaders=new HttpHeaders();
        headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
    return this.httpclient.get(this.global.G_apiUrl + '/approvedEmail/getStar/'+this.global.loggedUser.user.user_reg_id, { headers:headers });
    }
    
}